import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Operator,
  CreateOperatorRequest,
  UpdateOperatorRequest,
  OperatorsListParams,
  OperatorAvailability
} from '../types';

const { OPERATORS } = API_ENDPOINTS;

export const operatorsApi = {
  getAll: (params?: OperatorsListParams) =>
    apiClient.getPaginated<Operator>(OPERATORS.LIST, params),

  getById: (id: number) => apiClient.get<Operator>(OPERATORS.GET(id)),

  create: (data: CreateOperatorRequest) =>
    apiClient.post<Operator>(OPERATORS.CREATE, data),

  update: (id: number, data: UpdateOperatorRequest) =>
    apiClient.put<Operator>(OPERATORS.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(OPERATORS.DELETE(id)),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<OperatorsListParams> }
  ) => apiClient.post(OPERATORS.BULK_DELETE, params),

  updateAvailability: (id: number, status: OperatorAvailability) =>
    apiClient.patch<Operator>(OPERATORS.AVAILABILITY(id), { status })
};
